import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DeleteAccount from "../MyPage/DeleteAccount";
import { icSwiperPrevArrow } from "../../components/image/image-src";

const DeleteAccountMorePage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <style>
        {` .ui-footer {
            display: none
        }`}
      </style>

      <div className="relative flex h-[56px] w-full items-center justify-center">
        <img
          onClick={() => navigate(-1)}
          className="absolute left-[24px] top-1/2 mx-auto h-4 w-2.5 -translate-y-1/2"
          src={icSwiperPrevArrow}
          alt=""
        />
        <h2 className="text-lg font-semibold">{t("Delete account")}</h2>
      </div>

      <DeleteAccount isShowBtnDelete={false} />
    </>
  );
};

export default DeleteAccountMorePage;
